import React from "react";
import { Box } from "@mui/material";
import { C, METHOD_COLORS, statusStyle, MONO, roleColor, roleLabel, CATEGORY_INFO, categoryLabel } from "./usageTheme";

const pillSx = {
  display: "inline-flex",
  alignItems: "center",
  fontSize: 11,
  fontWeight: 700,
  px: "8px",
  py: "2px",
  borderRadius: "999px",
  lineHeight: 1.6,
  whiteSpace: "nowrap",
};

export function MethodPill({ method }) {
  const style = METHOD_COLORS[method] || { color: C.textBody, bg: C.gray7 };
  return (
    <Box component="span" sx={{ ...pillSx, fontFamily: MONO, fontSize: 10.5, color: style.color, background: style.bg }}>
      {method}
    </Box>
  );
}

export function StatusPill({ code }) {
  const style = statusStyle(code);
  return (
    <Box component="span" sx={{ ...pillSx, fontFamily: MONO, color: style.color, background: style.bg }}>
      {code}
    </Box>
  );
}

export function RolePill({ role }) {
  const color = roleColor(role);
  return (
    <Box component="span" sx={{ ...pillSx, fontWeight: 600, color: C.textBody, background: C.gray7, gap: "6px" }}>
      <Box component="span" sx={{ width: 7, height: 7, borderRadius: "50%", background: color }} />
      {roleLabel(role)}
    </Box>
  );
}

export function EndpointText({ endpoint }) {
  return (
    <Box component="span" sx={{ fontFamily: MONO, fontSize: 12, color: C.ink, wordBreak: "break-all" }}>
      {endpoint}
    </Box>
  );
}

export function CategoryPill({ category }) {
  if (!category) return null;
  const expected = CATEGORY_INFO[category]?.expected;
  return (
    <Box
      component="span"
      title={CATEGORY_INFO[category]?.hint}
      sx={{
        ...pillSx,
        fontWeight: 600,
        color: expected ? C.textSecondary : C.error,
        background: expected ? C.gray7 : C.errorBg,
      }}
    >
      {categoryLabel(category)}
    </Box>
  );
}
